import { render, staticRenderFns } from "./smstemplateadmin.vue?vue&type=template&id=4cb583a6&"
import script from "./smstemplateadmin.vue?vue&type=script&lang=js&"
export * from "./smstemplateadmin.vue?vue&type=script&lang=js&"
import style0 from "./smstemplateadmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports